module.exports = __webpack_public_path__ + "img/gateway5.ce322c24.png";